import api, { ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { ReadUsuarioDto } from '@/api.types';
import { FindUsuarioDto } from '@/api.types.extra';

export async function GetUsuarios(parameters: FindUsuarioDto) {
  if (parameters) {
    parameters.skip ??= 0;
    parameters.take ??= 10;
  }

  try {
    const response = await api.get<[ReadUsuarioDto[], number]>(Endpoints.USUARIO, { params: parameters });
    return response.data;
  } catch (error) {
    throw ValidateAxiosError(error, 'Falha ao buscar usuário(s).');
  }
}

export async function GetUsuarioBy(username: string) {
  return api
    .get<ReadUsuarioDto>(Endpoints.USUARIOBY + '/' + username)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return ValidateAxiosError<ReadUsuarioDto>(error, 'Falha ao bucar o usuário.');
    });
}

/**
 * Lista de permissões do usuário
 * @param {string} username
 * @returns Usuario ou null.
 */
export async function GetRolesFromUserName(username: string) {
  return api
    .get<string>(Endpoints.AUTH + '/roles/' + username)
    .then((res) => {
      return res.data;
    })
    .catch((error) => {
      return ValidateAxiosError<string>(error, 'Falha ao bucar permissões.');
    });
}